import { render } from "./WCModalHeader.vue?vue&type=template&id=4931294e"
import script from "./WCModalHeader.vue?vue&type=script&lang=js"
export * from "./WCModalHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__